<div class="wrapper">
  <div class="login-box text-center">
    <!-- <div  class="title-section mb-5">LOGIN</div> -->
    <img src="/assets/img/logo-blue.png" width="120" class="mb-5">

    <input class="mb-4" type="text" [(ngModel)]="user.nome" />
    <input class="mb-4" type="password" [(ngModel)]="user.password" />
  
    <div class="button button-green" (click)="login()">LOGIN</div>
  </div>
</div>